const maxTextArea = (value) => {
    if(typeof(value) === "string" && value.length > 10000){
        return("Must be less than 10,000 characters")
    }
}

export default maxTextArea;